import {
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    RadioGroup,
    TextField,
    Tooltip
} from "@material-ui/core";
import React, {useState} from "react";
import ConfirmDialog from "./ConfirmDialog";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PlatformRequest from "../utils/PlatformRequest";
import ModalDialog from "./ModalDialog";
import AlertMessage from "./AlertMessage";
import StorageService from "../services/StorageService";

const ActionHasNoHasPart = (props) => {
    const employerKey = "employer"
    const storageService = new StorageService();
    const [loadActions, setLoadActions] = React.useState(false)
    const [openHasPart, setOpenHasPart] = React.useState(false)
    const [hasPartInfo, setHasPartInfo] = React.useState(false)
    const [noHasPartInfo, setNoHasPartInfo] = React.useState(false)
    const [actionButton, setActionButton] = React.useState(true)
    const [employeeType, setEmployeeType] = useState(false)
    const [formError, setFormError] = React.useState({
        employer: false, contact: false
    })
    const [contactTypeList, setContactTypeList] = React.useState([
        {type: "", description: ""}
    ])
    const [employer, setEmployer] = React.useState("")
    const [contactList, setContactList] = React.useState([])
    const [alert, setAlert] = React.useState({
        severity: '',
        open: false,
        message: ''
    })

    const hasSuccess = () => {
        setLoadActions(false)
        setHasPartInfo(true)
        setActionButton(false)
        setNoHasPartInfo(false)

        if (props.callback) {
            props.callback(true)
        }
    }

    const addRemoveContactList = (event) => {
        const contactSelected = JSON.parse(event.target.value)
        let list = contactList
        const listFilter = contactList.filter((value) => value === contactSelected)

        if (listFilter.length === 0) {
            list.push(contactSelected)
            setContactList(list)
        } else {
            const listRemove = contactList.filter((value) => value !== contactSelected)
            setContactList(listRemove)
        }
    }

    const noHasSuccess = () => {
        setLoadActions(false)
        setHasPartInfo(false)
        setActionButton(false)
        setOpenHasPart(false)
        setNoHasPartInfo(true)

        if (props.callback) {
            props.callback(false)
        }
    }

    const providerHasPart = () => {
        if (employer === "" || employer === undefined) {
            return setFormError({...formError, employer: true})
        }

        if (contactList.length === 0) {
            return setFormError({...formError, contact: true})
        }

        const request = {
            employer: employer,
            contactList: contactList
        }
        localStorage.setItem(employerKey, employer)

        setOpenHasPart(false)
        setActionButton(false)
        setLoadActions(true)
        PlatformRequest.hasPart(props.search, request)
            .then(() => {
                hasSuccess()
            })
            .catch((err) => {
                let errMessage = "Houve um erro ao informar o cliente, tente novamente mais tarde"

                if (err.status === 410) {
                    errMessage = "Busca já finalizada"
                }

                setActionButton(true)
                setLoadActions(false)
                showAlert("error", errMessage)
            })
    }

    const showAlert = (severity, message) => {
        setAlert({severity: severity, message: message, open: true});
        setTimeout(() => {
            setAlert({...alert, open: false})
        }, 5000);
    }

    const openHasPartModal = () => {
        setLoadActions(true)
        setActionButton(false)

        const employee = storageService.getObjectLocalStorage("employee")
        if (employee !== null) {
            const {name, phone} = employee
            setEmployer(name)
            const contactList = {
                type: "WHATSAPP",
                description: phone
            }
            setContactList([contactList])
            setActionButton(true)
            setLoadActions(false)
            setOpenHasPart(true)
            setEmployeeType(true)
            return
        }

        PlatformRequest.getAuthProvider()
            .then((response) => {
                const {body} = response
                const {contactTypeList} = body

                const employerSaved = localStorage.getItem(employerKey)
                if (employerSaved !== undefined && employerSaved !== null) {
                    setEmployer(employerSaved)
                } else {
                    setEmployer(body.fancyName)
                }

                setContactTypeList(contactTypeList)
                setActionButton(true)
                setLoadActions(false)
                setOpenHasPart(true)
            })

    }

    const notHasPart = () => {
        setLoadActions(true)
        setActionButton(false)
        PlatformRequest.noHasPart(props.search)
            .then(() => {
                noHasSuccess()
            })
    }

    const hasPart = <Chip label="Possui a peça" icon={<CheckCircleOutlineIcon/>} color="secondary"/>
    const noHasPart = <Chip label="Não possui a peça" icon={<DeleteForeverIcon/>} color="primary"/>
    const buttons = <Grid container
                          direction="row"
                          alignItems="center"
                          spacing={2}>
        <Grid item>
            <ConfirmDialog
                title="Tem certeza que não possui a peça?"
                tooltip={props.tooltipNoHas}
                description="Após confirmar, não será possível ver mais essa busca."
                iconButton={props.buttonNoHasPartText}
                color="primary"
                textConfirm="Sim, desejo remover essa busca"
                textBack="Cancelar"
                variant={props.hasVariant ? props.hasVariant : "text"}
                yesButtonAction={notHasPart}/>
        </Grid>
        <Grid item>
            <Tooltip title={props.tooltipHas} arrow>
                <Button
                    onClick={openHasPartModal}
                    variant={props.hasVariant ? props.hasVariant : "text"}
                    color="secondary">
                    {props.buttonHasPartText}
                </Button>
            </Tooltip>
        </Grid>
    </Grid>
    const hasPartModal = <ModalDialog
        title={employeeType ? "Deseja informar o cliente que possui a peça?" : "Informe os dados de contato para o cliente"}
        label=""
        open={openHasPart}
        textSave={employeeType ? "Sim" : "Informar ao cliente que possuo a peça"}
        close={() => {
            setOpenHasPart(false)
        }}
        subTitle=""
        saveMethod={providerHasPart}>
        {
            employeeType ? null :
                <Grid container direction="row" spacing={3}>
                    <Grid item xs={12} lg={12} md={12}>
                        <TextField
                            label="Funcionário"
                            value={employer}
                            autoFocus
                            color="secondary"
                            error={formError.employer}
                            InputProps={{
                                readOnly: employeeType
                            }}
                            onChange={(event) => {
                                setEmployer(event.target.value)
                            }}
                            helperText="Nome do funcionário que o cliente irá entrar em contato"
                            variant="outlined"
                            fullWidth/>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                        <FormControl component="fieldset" error={formError.contact}>
                            <FormLabel component="legend">Contato</FormLabel>
                            <FormHelperText>selecione os contatos que serão enviados para o cliente</FormHelperText>
                            <RadioGroup defaultValue="female" aria-label="gender" name="customized-radios">
                                {
                                    contactTypeList.map((contact) => (
                                        <FormControlLabel
                                            value={JSON.stringify(contact)}
                                            control={<Checkbox onChange={addRemoveContactList}/>}
                                            label={contact.description}/>
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
        }
    </ModalDialog>

    const load = <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}>
        <Grid item>
            <CircularProgress size={20}/>
        </Grid>
    </Grid>

    return (
        <div>
            <AlertMessage severity={alert.severity} message={alert.message} open={alert.open}/>
            {hasPartInfo ? hasPart : null}
            {noHasPartInfo ? noHasPart : null}
            {loadActions ? load : null}
            {actionButton ? buttons : null}
            {hasPartModal}
        </div>
    )

}

export default ActionHasNoHasPart